export default ($http) => ({
  addOwner (payload) {
    return $http.put('attachments/add-owner', { body: payload })
  },
  create (payload) {
    return $http.post('attachments', { body: payload })
  },
  delete (id) {
    return $http.delete(`attachments/${id}`)
  },
  createFile (payload) {
    return $http.post('attachment/file', { body: payload, headers: { 'Content-Type': 'multipart/form-data' }, timeout: 600000 })
  },
  updateFile (id, payload) {
    return $http.put(`attachment/file/${id}`, { body: payload })
  },
  createLink (payload) {
    return $http.post('attachment/link', { body: payload })
  },
  updateLink (id, payload) {
    return $http.put(`attachment/link/${id}`, { body: payload })
  },
  saveLinks (payload) {
    return $http.post('attachment/storeMany', { body: payload })
  },
  updateOrder (payload) {
    return $http.put(`attachments/change-order/${payload.id}`, { body: payload })
  },
  createFaithJourneyLink (payload) {
    return $http.post('attachments/faith-journey-link', { body: payload })
  },
  updateFaithJourneyLink (id, payload) {
    return $http.put(`attachments/faith-journey-link/${id}`, { body: payload })
  }
})
